export default "__VITE_ASSET__302cefec__"